import { render, staticRenderFns } from "./VrstaSudionikaEdit.vue?vue&type=template&id=6a7b36dc&scoped=true&"
import script from "./VrstaSudionikaEdit.vue?vue&type=script&lang=js&"
export * from "./VrstaSudionikaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7b36dc",
  null
  
)

export default component.exports